import {createSlice} from "@reduxjs/toolkit";
import {ResponseApi} from '../BaseApi';
import {CreateFine, GetAllFineTypes} from './TrafficFinesApi';

const TrafficFinesSlice = createSlice({
    name: "trafficFinesSection",
    initialState: {
        fineTypesAll: [],
        addFine: null
    },
    reducers: {
        resetFineTypesAll: (state, action) => {
            state.fineTypesAll = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(GetAllFineTypes.fulfilled, (state, {payload}) =>{
            state.fineTypesAll = ResponseApi(payload);
        }).addCase(CreateFine.fulfilled, (state, {payload}) =>{
            state.addFine = ResponseApi(payload);
        })
    }
})

export const {  } = TrafficFinesSlice.actions;

export default TrafficFinesSlice.reducer;
